<template>
  <div class="button-icon-container">
    <div
      class="button"
      :class="{ selected: isSelected }"
      @click="toggleSelected"
    >
      <slot name="icon">
        <md-icon
          :md-src="srcIcon"
          :class="color"
          :style="{ backgroundColor: color }"
        >
          {{ label }}
        </md-icon>
        <md-tooltip
          v-if="hint"
          class="tooltip-small"
        >
          <span>{{ hint }}</span>
        </md-tooltip>
      </slot>
      <span v-if="label">{{ label }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonIcon',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    srcIcon: {
      type: String,
      default: '/static/images/icon-frozen.svg'
    },
    color: {
      type: String,
      default: 'background-color-malibu'
    },
    hint: {
      type: String,
      default: ''
    }
  },
  emits: ['input'],
  computed: {
    isSelected: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    toggleSelected() {
      this.isSelected = !this.isSelected
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../static/stylesheets/variables';

.button-icon-container {
  font-size: 12px;
  color: $label-color;
  font-weight: 400;
  display: flex;

  .button {
    cursor: pointer;
    opacity: 0.3;
    transition: opacity 0.3s, transform 0.3s;

    &:hover {
      transform: scale(1.1);
    }

    &.selected {
      opacity: 1;
    }

    .md-icon {
      border-radius: 100%;
      padding: 5px;
      width: 30px;
      height: 30px;
      color: white;
      box-shadow: 0 2px 3px 1px rgba(0, 0, 0, 0.3);
    }
  }

  span {
    margin-left: 10px;
  }
}
</style>
